/**
 * Combine per-criterion match results for persona filters.
 *
 * Left-to-right fold in panel order (see evaluateFilter): the first active
 * criterion seeds the result; each later criterion combines with AND or OR
 * depending on its own operator. The first criterion's operator is ignored.
 *
 * @param {Array<{ matches: boolean, operator?: string }>} results
 * @returns {boolean}
 */
export function combineFilterMatches(results) {
  const list = Array.isArray(results) ? results : [];
  if (!list.length) return true;

  let accumulated = null;

  for (const item of list) {
    const matches = Boolean(item?.matches);
    if (accumulated === null) {
      accumulated = matches;
      continue;
    }
    if (item?.operator === 'or') {
      accumulated = accumulated || matches;
    } else {
      accumulated = accumulated && matches;
    }
  }

  return accumulated !== null ? accumulated : true;
}
